mutation DeleteStreamEntrypoints($ids: [ID!]!) {
  deleteStreamEntrypoints(ids: $ids)
}
